import { Spacing } from 'zens-storybook'
import React, { Suspense } from 'react'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useNumberParams } from 'zens-router'
import { useBreadcrumb } from '@dms/hook'
import { HomeCompany, BuildingInsights, HomeWelcome, LayoutHeader, InfoBlock } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    marginHorizontal: Spacing.L,
    marginTop: Spacing.S,
    marginBottom: Spacing.L,
  },
  block: {
    marginTop: Spacing.M,
  },
})

const CompanyHome = () => {
  const { t } = useTranslation()
  const [{ companyId }] = useNumberParams()
  const breadcrumb = useBreadcrumb([])

  return (
    <View style={styles.container}>
      <LayoutHeader title={t('Home')} breadcrumb={breadcrumb} />
      <View style={styles.content}>
        <HomeWelcome />
        <Suspense fallback={<InfoBlock.Skeleton style={styles.block} title />}>
          <HomeCompany companyId={companyId} style={styles.block} />
        </Suspense>
        <Suspense fallback={<BuildingInsights.Skeleton style={styles.block} title={t('Insights')} />}>
          <BuildingInsights title={t('Insights')} companyId={companyId} style={styles.block} />
        </Suspense>
      </View>
    </View>
  )
}

export default CompanyHome
